import Company from '../interfaces/Company';
import User from '../interfaces/User';
import { isEnterpriseCustomer } from './pricingUpgradeRules';

function canManageIntegrations(user: User | null | undefined): boolean {
  const role = (user?.role || '').trim().toLowerCase();
  return Boolean(
    user?.permissions?.manage_integrations ||
      user?.permissions?.admin ||
      role === 'owner'
  );
}

/**
 * CRM / Integrations (Zapier-backed connectors) are Business+ features in pricing
 * and require ``manage_integrations``, structural ``admin``, or company Owner role
 * (retroactive for creators who predate the dedicated flag).
 * Enterprise is included via plan_tier, plan_id, or the enterprise flag.
 */
export function canAccessIntegrations(
  company: Company | null | undefined,
  user: User | null | undefined
): boolean {
  if (!company || !canManageIntegrations(user)) return false;
  if (isEnterpriseCustomer(company)) return true;
  return company.plan_tier === 'business';
}
